<form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
  <div class="flex flex-col gap-6 rounded-2xl bg-white p-6 shadow-sm">
    <h3 class="text-primary text-[20px] font-[600]" i18n="@@adminAddCategoryTitle">Category Information</h3>

    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-2">
        <label class="text-[14px] font-[500]" i18n="@@adminProductFormTitleEnLabel">
          Title (En)
        </label>
        <input
          type="text"
          formControlName="titleEn"
          placeholder="Enter category title in English (optional)"
          i18n-placeholder="@@adminCategoryFormTitleEnPlaceholder"
          class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
          [class.border-red-500]="categoryForm.get('titleEn')?.invalid && categoryForm.get('titleEn')?.touched" />
        @if (categoryForm.get("titleEn")?.invalid && categoryForm.get("titleEn")?.touched) {
          <span class="text-danger-text text-[12px]">
            @if (
              categoryForm.get("titleEn")?.errors?.["minlength"] || categoryForm.get("titleEn")?.errors?.["maxlength"]
            ) {
              <span i18n="@@adminCategoryFormErrorTitleLength">Title must be between 2 and 100 characters</span>
            }
          </span>
        }
      </div>

      <div class="flex flex-col gap-2" dir="rtl">
        <label class="text-[14px] font-[500]">
          <span i18n="@@adminProductFormTitleArLabel">Title (Ar)</span>
          <span class="text-danger-text">*</span>
        </label>
        <input
          type="text"
          formControlName="titleAr"
          placeholder="Enter category title in Arabic"
          i18n-placeholder="@@adminCategoryFormTitleArPlaceholder"
          class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none" />
        @if (categoryForm.get("titleAr")?.invalid && categoryForm.get("titleAr")?.touched) {
          <span class="text-danger-text text-[12px]">
            @if (categoryForm.get("titleAr")?.errors?.["required"]) {
              <span i18n="@@adminCategoryFormErrorTitleArRequired">Arabic title is required</span>
            } @else if (categoryForm.get("titleAr")?.errors?.["minlength"] || categoryForm.get("titleAr")?.errors?.["maxlength"]) {
              <span i18n="@@adminCategoryFormErrorTitleArRange">Arabic title must be between 2 and 100 characters</span>
            } @else if (categoryForm.get("titleAr")?.errors?.["notArabic"] || categoryForm.get("titleAr")?.errors?.["hasNumbers"]) {
              <span i18n="@@adminCategoryFormErrorTitleArCharacters">Arabic title must contain Arabic letters only</span>
            } @else if (categoryForm.get("titleAr")?.errors?.["leadingTrailingSpaces"]) {
              <span i18n="@@adminCategoryFormErrorTitleArSpaces">Arabic title cannot start or end with spaces</span>
            }
          </span>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[14px] font-[500]" i18n="@@adminProductFormDescEnLabel">Description (En)</label>
        <textarea
          formControlName="descriptionEn"
          placeholder="Enter description in English"
          i18n-placeholder="@@adminCategoryFormDescEnPlaceholder"
          rows="4"
          class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"></textarea>
      </div>

      <div class="flex flex-col gap-2" dir="rtl">
        <label class="text-[14px] font-[500]" i18n="@@adminProductFormDescArLabel">Description (Ar)</label>
        <textarea
          formControlName="descriptionAr"
          placeholder="Enter description in Arabic"
          i18n-placeholder="@@adminCategoryFormDescArPlaceholder"
          rows="4"
          class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"></textarea>
      </div>

      <div class="col-span-2 flex flex-col gap-2">
        <label class="text-[14px] font-[500]" i18n="@@adminCategoryFormLogoLabel">Logo</label>
        <div
          class="border-border hover-border-gray flex flex-col items-center justify-center gap-2 rounded-[6px] border-2 border-dashed py-[40px]"
          [class.border-red-500]="!selectedImage && formSubmitted"
          [class.border-primary]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" viewBox="0 0 24 24" class="text-gray">
            <path
              fill="currentColor"
              d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
          </svg>
          <p class="text-neutral-text text-[14px]" i18n="@@adminProductFormUploadText">
            Click to upload or drag and drop
          </p>
          <p class="text-gray text-[12px]" i18n="@@adminProductFormMaxFileSize">Max file Size: 5MB</p>
          <button
            type="button"
            (click)="fileInput.click()"
            class="bg-primary hover-bg-primary-hover mt-2 rounded-[6px] px-6 py-2 text-[14px] font-[500] text-white hover:cursor-pointer"
            i18n="@@adminProductFormBrowseButton">
            Browse File
          </button>
          <input #fileInput type="file" accept="image/png,image/jpeg" (change)="onFileSelect($event)" class="hidden" />
        </div>
        @if (imagePreview) {
          <div class="border-border mt-2 flex items-center gap-2 rounded-[8px] border p-2">
            <img [src]="imagePreview" alt="Preview" class="h-[60px] w-[60px] rounded-[4px] object-cover" />
            <div class="flex-1">
              <p class="text-black-soft text-[13px] font-[500]">{{ selectedImage?.name }}</p>
            </div>
            <button
              type="button"
              (click)="removeImage()"
              class="text-primary hover-text-primary-hover hover:cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
              </svg>
            </button>
          </div>
        }
        @if (!selectedImage && formSubmitted) {
          <span class="text-danger-text text-[12px]" i18n="@@adminCategoryFormErrorLogoRequired">Logo is required</span>
        }
      </div>
    </div>
  </div>

  @if (errorCreatingCategory()) {
    <div class="rounded-[6px] border border-red-200 bg-red-50 px-4 py-3">
      <p class="text-[14px] text-red-800">{{ errorCreatingCategory() }}</p>
    </div>
  }

  <div class="flex justify-end gap-3">
    <button
      type="button"
      (click)="onCancel()"
      class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
      <span i18n="@@adminCategoryFormCancelButton">Cancel</span>
    </button>
    <button
      type="submit"
      [disabled]="loading()"
      class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer disabled:opacity-50">
      @if (loading()) {
        <span i18n="@@adminCategoryFormSavingButton">Saving...</span>
      } @else {
        <span i18n="@@adminCategoryFormSaveButton">Save</span>
      }
    </button>
  </div>
</form>
